module.exports = __webpack_public_path__ + "static/media/michael-kiley.e2b4a606.md";